import { RSAA } from 'redux-api-middleware';
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import { getBffApiUrl } from '@makemydeal/dr-dash-ui-utils';
import {
    FETCH_DEALERSHIPS_REQUEST,
    FETCH_DEALERSHIPS_SUCCESS,
    FETCH_DEALERSHIPS_FAILURE
} from '../actionTypes/dealershipsActionTypes';

export const fetchDealerships = (bridgeId: string) => {
    const endpoint = `${getBffApiUrl('dealerships')}?bridgeId=${bridgeId}`;
    const request: RSAACallRequest = {
        endpoint,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [FETCH_DEALERSHIPS_REQUEST, FETCH_DEALERSHIPS_SUCCESS, FETCH_DEALERSHIPS_FAILURE],
        fetch: async (input: RequestInfo | URL, init?: RequestInit) => await fetch(input, init)
    };
    return {
        [RSAA]: request
    } as RSAACallAction;
};
